import { Device, Call, TwilioError } from "./twilio.min.js";


export type Config = {
    lvtLiveUnitId : string,
    token : string,
    callConnected: ()=>void,
    callStoppedFailure: (error: string)=>void,
    callStoppedSuccess: ()=>void,
}
export type CallControls = {
    muteLocal : ()=>void,
    unmuteLocal : ()=>void,
    hangup : ()=>void,
}

export const startTwilioCall = (config: Config):CallControls => {

    const lvtLiveUnitId = config.lvtLiveUnitId;
    const token = config.token;

    let micAccess = false;
    let connected = false;
    let hangUpInitiatedByUser = false;
    let ended = false;
    let call: Call | undefined;

    navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(()=> {
        micAccess = true;
    });

    const device = new Device(token, {
        logLevel: 1,
        // Set Opus as our preferred codec. Opus generally performs better, requiring less bandwidth and
        // providing better audio quality in restrained network conditions.
        codecPreferences: ["opus", "pcmu"],
    });

    device.on("error", (error: TwilioError) => {
        console.error("Twilio.Device Error: " + error.message);
        callHangup();
    });

    function callAnswered() {
        connected = true;
        config.callConnected();
    }

    function callHangup() {
        if (!ended) {
            if (!micAccess) {
                config.callStoppedFailure("This feature requires microphone access.");
            } else if (!connected) {
                config.callStoppedFailure("Unable to connect to speaker.");
            } else if (!hangUpInitiatedByUser) {
                config.callStoppedFailure("Speaker disconnected.");
            } else {
                config.callStoppedSuccess();
            }

            endConnection();
        }
    }

    async function makeOutgoingCall() {
        const params = {
          LiveUnitId: lvtLiveUnitId,
        };

        if (device) {
          console.log(`Attempting to call ${params.LiveUnitId} ...`);

          call = await device.connect({ params });

          // add listeners to the Call
          // "accepted" means the call has finished connecting and the state is now "open"
          call.on("accept", callAnswered);
          call.on("disconnect", callHangup);
          call.on("cancel", callHangup);
          call.on("error", callHangup);
        } else {
          console.log("Unable to make call.");
          endConnection();
        }
    }

    makeOutgoingCall();

    const muteLocal = () => {
        if(call) {
            call.mute();
        }
    };

    const unmuteLocal = () => {
        if(call) {
            call.mute(false);
        }
    };

    const hangup = () => {
        hangUpInitiatedByUser = true;

        if(call) {
            call.disconnect();
        }
    };


    const handler = ()=>{
        hangup();
    };

    window.addEventListener("beforeunload", handler);
    function endConnection() {
        ended = true;
        window.removeEventListener("beforeunload", handler);

        if(device) {
            device.destroy();
            call = undefined;
        }
    }

    return {
        muteLocal,
        unmuteLocal,
        hangup,
    };
};
